import { render, staticRenderFns } from "./OrgSettingsCompensation.vue?vue&type=template&id=e0872a14&scoped=true&"
import script from "./OrgSettingsCompensation.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsCompensation.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsCompensation.vue?vue&type=style&index=0&id=e0872a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0872a14",
  null
  
)

export default component.exports